(ns pfo.comment.model
  (:require [pfo.util :as util]))

(defn conversation-subject [conversation]
  (if-let [subject (not-empty (:subject conversation))]
    subject
    (util/ellipsis (:plaintext_body (last (:comments conversation))) 10)))
